type ButtonProps = {
    children: React.ReactNode;
    onClick?: () => void;
    type?: 'button' | 'submit';
    variant?: 'primary' | 'secondary' | 'quiet';
    disabled?: boolean;
    size?: 'sm' | 'md' | 'lg';
    /** Fills its container, for a CTA stacked under a field on a phone. */
    block?: boolean;
};

/**
 * `primary` is the brand action colour. Secondary is structural (outline);
 * quiet is muted text. Soft/state hues are for badges and notes, not CTAs.
 */
const VARIANTS = {
    primary: 'bg-primary text-text-on-primary border-primary hover:bg-primary-hover hover:border-primary-hover',
    secondary: 'bg-surface text-secondary border-border-strong hover:border-secondary',
    quiet: 'bg-transparent text-text-muted border-transparent hover:text-text hover:underline',
} as const;

const SIZES = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-3 text-base',
} as const;

export function Button({
    children,
    onClick,
    type = 'button',
    variant = 'primary',
    disabled = false,
    size = 'md',
    block = false,
}: ButtonProps) {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`inline-flex items-center justify-center gap-2 rounded-md border font-medium transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-45 ${
                VARIANTS[variant]
            } ${SIZES[size]} ${block ? 'w-full' : ''}`}
        >
            {children}
        </button>
    );
}
